import {createSelector} from 'reselect';
import {
  buildEditorSections,
  buildSections,
} from '../../utils/MyWeather/sections';
import {getFavoriteLocations, getRecentLocations} from '../location/selectors';
import {CommonRootState} from '../types';
import {
  getSortedStationList,
  selectFavoriteStationIds,
} from '../weather/selectors';

export const selectPendingStationIds = (state: CommonRootState) =>
  state.myWeather.pendingStationIds;

export const selectMyWeatherOrder = (state: CommonRootState) =>
  state.myWeather.order;

export const selectMyWeatherOrderPending = (state: CommonRootState) =>
  state.myWeather.orderPending;

export const selectMyWeatherOrderStationIds = (state: CommonRootState) =>
  state.myWeather.orderStationIds;

/** The My weather list's sections (FE #381), both apps. */
export const selectMyWeatherSections = createSelector(
  getSortedStationList,
  selectFavoriteStationIds,
  getFavoriteLocations,
  getRecentLocations,
  selectMyWeatherOrder,
  (stations, favoriteStationIds, favoritePlaces, recentPlaces, order) =>
    buildSections({
      stations,
      favoriteStationIds,
      favoritePlaces,
      recentPlaces,
      order,
    }),
);

/** The My weather editor's groups (FE #381 step 3), both apps. */
export const selectMyWeatherEditorSections = createSelector(
  getSortedStationList,
  selectFavoriteStationIds,
  getFavoriteLocations,
  selectMyWeatherOrder,
  (stations, favoriteStationIds, favoritePlaces, order) =>
    buildEditorSections({stations, favoriteStationIds, favoritePlaces, order}),
);
